import localStorageManager from '@/utils/localStorageManager'

const jwtStore = new localStorageManager('jwtStore', 60 * 24) // 24 hours TTL

export default jwtStore
